import React, { useState, useEffect } from 'react';
import ProjectList from '../Organisms/ProjectList';
import ProjectPhase from '../Organisms/ProjectPhase';
import useProjects from '../../hooks/useProjects';
import { Login } from '@mui/icons-material';

const ProjectsLayout = ({ selectedPage, updatePage, selectedPhase, setIsSelectedProject, selectedProject, setProjectName, token, serviceProvider, freeProject = [], handleShowSubscriptionsWall = null, onlyTemplates,  showProjectForm = false }) => {

  const [project, setProject] = useState(selectedProject);
  const [newTemplateFromProject, setNewTemplateFromProject] = useState(false);
  const { projects, loading, error, addProject, removeProject, editProject, getProjects } = useProjects(token);

  useEffect(() => {
    setProject(selectedProject);
  }, [selectedProject])
  

  const changeProjectToTemplate = () => {    
    updatePage('Templates');
    setNewTemplateFromProject(true);
  }

  const renderPageContent = (selectedPhase) => {
    switch (selectedPhase) {
      case 'Feasibility Phase':
        return <ProjectPhase
          selectedPhase={selectedPhase}
          project={project}
          token={token}
          serviceProvider={serviceProvider}
          subscription={serviceProvider?.subscription}
          handleShowSubscriptionsWall={handleShowSubscriptionsWall}
          changeProjectToTemplate={changeProjectToTemplate}

        />;
      case 'Planning Phase':
        return <ProjectPhase
          selectedPhase={selectedPhase}
          project={project}
          token={token}
          serviceProvider={serviceProvider}
          subscription={serviceProvider?.subscription}
          handleShowSubscriptionsWall={handleShowSubscriptionsWall}
          changeProjectToTemplate={changeProjectToTemplate}
        />;
      case 'Construction Phase':
        return <ProjectPhase
          selectedPhase={selectedPhase}
          project={project}
          token={token}
          serviceProvider={serviceProvider}
          subscription={serviceProvider?.subscription}
          handleShowSubscriptionsWall={handleShowSubscriptionsWall}
          changeProjectToTemplate={changeProjectToTemplate}
        />;
      case 'Handover / Closeout Phase':
        return <ProjectPhase
          selectedPhase={selectedPhase}
          project={project}
          token={token}
          serviceProvider={serviceProvider}
          subscription={serviceProvider?.subscription}
          handleShowSubscriptionsWall={handleShowSubscriptionsWall}
          changeProjectToTemplate={changeProjectToTemplate}
        />;
      case 'Work Breakdown Structure':
        return <ProjectPhase
          selectedPhase={selectedPhase}
          project={project}
          token={token}
          serviceProvider={serviceProvider}
          subscription={serviceProvider?.subscription}
          editProject={editProject}
          handleShowSubscriptionsWall={handleShowSubscriptionsWall}
          changeProjectToTemplate={changeProjectToTemplate}
        />;
      case 'Account':
        return <ProjectPhase selectedPhase={selectedPhase} project={project} token={token} serviceProvider={serviceProvider} />;
      default:
        return (
          <ProjectList
            projects={projects.length ? projects : freeProject == 0 ? [] : [freeProject]}
            loading={loading}
            addProject={addProject}
            removeProject={removeProject}
            editProject={editProject}
            setIsSelectedProject={setIsSelectedProject}
            setProjectName={setProjectName}
            selectProject={setProject}
            subscription={serviceProvider?.subscription}
            userEmail={serviceProvider?.email_address}
            isProjectManager={serviceProvider?.is_project_manager}
            onlyTemplates={onlyTemplates}
            selectedPage={selectedPage}
            updatePage={updatePage}
            newTemplateFromProject={newTemplateFromProject}
            setNewTemplateFromProject={setNewTemplateFromProject}
            newTemplateFromProjectData={project}
            showProjectForm={showProjectForm}
          />
        );
    }
  };



  return (
    <div>
      {!serviceProvider?.subscription &&
        <div className='alert alert-warning'>
          This is a demo project. If you want to create and manage your own project, you need to log in or sign up.
        </div>
      }
      <div className="mt-2">
        {(selectedPage === 'Projects' || selectedPage === 'Templates') && (
          renderPageContent(selectedPhase)
        )}
      </div>
    </div>
  );
};

export default ProjectsLayout;
